import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import { Stack } from '@mui/system';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import type Framework from 'benchmarking-domain/framework';
import { DataGridArrayColumnSortComparator, DataGridInMemory } from 'components/core/shared/data-grid-in-memory';
import { nameOf } from 'helpers/nameof';
import { paths } from 'paths';
import { useNavigate } from 'react-router-dom';

interface FrameworksTableProps {
  rows?: Framework[];
}

export function FrameworksTable({ rows = [] }: FrameworksTableProps): React.JSX.Element {
  const navigate = useNavigate();

  const columns: GridColDef[] = [
    {
      field: nameOf<Framework>('name'),
      headerName: 'Name',
      flex: 1,
      minWidth: 200,
    },
    {
      field: nameOf<Framework>('technologies'),
      headerName: 'Technologies',
      flex: 1,
      minWidth: 200,
      sortComparator: DataGridArrayColumnSortComparator,
      renderCell: (params: GridRenderCellParams<Framework, string[]>) => (
        <Box sx={{ display: 'inline-flex', flexWrap: 'wrap', gap: 1, padding: 1 }}>
          {params.value?.map((technology) => <Chip key={technology} color="default" label={technology} size="small" />)}
        </Box>
      ),
    },
    {
      field: nameOf<Framework>('status'),
      headerName: 'Status',
      minWidth: 150,
    },
    {
      field: 'actions',
      headerName: 'Actions',
      minWidth: 180,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams<Framework>) => {
        return (
          <Stack direction="row" spacing={1} sx={{ marginY: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                navigate(paths.app.admin.frameworks.getDetailsUrl(params.row.id));
              }}
            >
              View&nbsp;framework
            </Button>
          </Stack>
        );
      },
    },
  ];

  return <DataGridInMemory columns={columns} rows={rows} searchPlaceholder="Search frameworks" />;
}
